// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Checkbox {
  cursor: pointer;
}
.n-Checkbox__native-input {
  opacity: 0;
  width: 0;
  position: absolute;
}
.n-Checkbox__icon-container {
  width: 16px;
  height: 16px;
  position: relative;
  display: inline-block;
}
.n-Checkbox:focus-within .n-Checkbox__icon-container {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
  border-radius: 1px;
}
.n-Checkbox__icon {
  position: absolute;
  top: 8px;
  left: 8px;
  transform: translate(-50%, -50%);
}
.n-Checkbox.n--disabled .n-Checkbox__icon-container {
  opacity: 50%;
}
.n-Checkbox.n--disabled {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/checkbox/Checkbox.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AALA;EACE,eAAA;AAOF;AALE;EACE,UAAA;EACA,QAAA;EACA,kBAAA;AAOJ;AAJE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAMJ;AAHE;ECnBA,mBAAA;EACA,4CAAA;EDoBE,kBAAA;AAMJ;AAHE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAKJ;AAFE;EACE,YAAA;AAIJ;AADE;EACE,oBAAA;AAGJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n@checkboxSize: @layoutUnit-sm * 2;\n\n.n-Checkbox {\n  cursor: pointer;\n\n  &__native-input {\n    opacity: 0;\n    width: 0;\n    position: absolute;\n  }\n\n  &__icon-container {\n    width: @checkboxSize;\n    height: @checkboxSize;\n    position: relative;\n    display: inline-block;\n  }\n\n  &:focus-within &__icon-container {\n    .n-outline();\n    border-radius: 1px;\n  }\n\n  &__icon {\n    position: absolute;\n    top:(@checkboxSize / 2);\n    left:(@checkboxSize / 2);\n    transform: translate(-50%, -50%);\n  }\n\n  &.n--disabled &__icon-container {\n    opacity: 50%;\n  }\n\n  &.n--disabled {\n    pointer-events: none;\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
